import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useScrollToSection } from '../../hooks/useScrollToSection';
import { NAVIGATION_ITEMS } from '../../data/constants';
import './Header.css';

export const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const scrollToSection = useScrollToSection();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    const onResize = () => { if (window.innerWidth > 768) setMenuOpen(false); };
    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onResize);
    return () => { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onResize); };
  }, []);

  const nav = (id: string) => { scrollToSection(id); setMenuOpen(false); };

  return (
    <motion.header
      className={`header ${scrolled ? 'header--scrolled' : ''}`}
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22,1,0.36,1] }}
    >
      <div className="container">
        <div className="header__row">
          {/* Monogram logo */}
          <motion.button
            className="header__logo"
            onClick={() => nav('home')}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.96 }}
          >
            <span className="header__logo-mark">SD</span>
            <span className="header__logo-name">Supratick Dey</span>
          </motion.button>

          {/* Desktop nav */}
          <nav className="header__nav" aria-label="Main navigation">
            {NAVIGATION_ITEMS.map(item => (
              <button key={item.id} className="header__nav-link" onClick={() => nav(item.id)}>
                {item.label}
              </button>
            ))}
          </nav>

          {/* CTA */}
          <div className="header__cta">
            <motion.button
              className="btn btn--primary btn--sm"
              onClick={() => nav('contact')}
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.97 }}
            >
              Contact
            </motion.button>
          </div>

          {/* Hamburger */}
          <button
            className={`header__burger ${menuOpen ? 'header__burger--open' : ''}`}
            onClick={() => setMenuOpen(v => !v)}
            aria-label="Toggle menu"
          >
            <span /><span /><span />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className="header__mobile"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3, ease: [0.22,1,0.36,1] }}
          >
            {NAVIGATION_ITEMS.map(item => (
              <button key={item.id} className="header__mobile-link" onClick={() => nav(item.id)}>
                {item.label}
              </button>
            ))}
            <button className="btn btn--primary" style={{ marginTop: '8px', width: '100%', justifyContent: 'center' }} onClick={() => nav('contact')}>
              Contact
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
